import 'css-chunksrc/client/pages/zonesPage/reportsPage/loader/reportLoader/styles.scss';export default {
  "report": "_report_11vgn_1",
  "nameBox": "_nameBox_11vgn_15",
  "projectName": "_projectName_11vgn_23",
  "separator": "_separator_11vgn_29",
  "reportName": "_reportName_11vgn_34",
  "row": "_row_11vgn_40",
  "label": "_label_11vgn_47",
  "author": "_author_11vgn_54",
  "authorAvatar": "_authorAvatar_11vgn_63",
  "authorName": "_authorName_11vgn_74",
  "text": "_text_11vgn_80",
  "indicators": "_indicators_11vgn_85"
};